import { Routes } from '@angular/router';

export const hrLogModalRoutes: Routes = [
  {
    path: 'hrlog/full-history',
    outlet: 'modal',
    loadChildren: () => import('./full-history/hrlog-full-history-modal.module').then((m) => m.HrLogFullHistoryModalModule)
  }
];
